module.exports = __webpack_public_path__ + "static/media/pattern-view-icon.39a89df1.svg";